module.exports = __webpack_public_path__ + "media/images/pic/saska-contact-choice-f7216bac1cbc68308b305e5a385a7725.svg";